import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
import "../../../styles/Auth/subscription.css";
const SubscriptionPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = sessionStorage.getItem("role");
    const adminStoreIds = JSON.parse(sessionStorage.getItem("storeIds") || "[]");
    const initialStoreId = sessionStorage.getItem("currentStoreId") ||
        (role === "Admin" ? adminStoreIds[0] || "" : "");
    const [stores, setStores] = useState([]);
    const isAddSubscription = location.pathname === '/subscriptions/add';
    const [searchQuery, setSearchQuery] = useState('');
    const [subscriptions, setSubscriptions] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [open, setOpen] = useState(false);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editSubscriptionId, setEditSubscriptionId] = useState(null);
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const colors = ["#F9F1EC", "#F7EAE2", "#EBDDDF"];
    const [formData, setFormData] = useState({
        subscriptionName: '',
        subscriptionCycle: '',
        price: '',
        subscriptionDescription: '',
        storeId: initialStoreId,
    });
    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleAddSubscription = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const response = await postData('subscriptions/newsubscription', formData, token);
            toast.success(response.message || 'Subscription added successfully');
            setFormData({
                subscriptionName: '',
                subscriptionCycle: '',
                price: '',
                subscriptionDescription: ''
            });
            triggerRefresh();
            navigate("/subscriptions");
        } catch (error) {
            console.error('Add Subscription Error:', error);
            toast.error(error.message || 'Add Subscription Failed');
        }
    };

    const handleUpdateSubscription = async (e) => {
        e.preventDefault();
        debugger;
        try {
            const token = sessionStorage.getItem("Token");
            const updatedSubscriptionData = {
                subscriptionName: formData.subscriptionName,
                subscriptionCycle: formData.subscriptionCycle,
                price: formData.price,
                subscriptionDescription: formData.subscriptionDescription,
                storeId: formData.storeId
            };
            console.log("Updating Subscription with data:", updatedSubscriptionData);

            const response = await putData(`subscriptions/${editSubscriptionId}`, updatedSubscriptionData, token);

            toast.success(response.message || 'Subscription updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                subscriptionName: '',
                subscriptionCycle: '',
                price: '',
                subscriptionDescription: '',
                storeId: ''
            });
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchSubscriptions();
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating subscription.");
        }
    };

    useEffect(() => {
        fetchSubscriptions(searchQuery, selectedStoreId);
    }, [refreshKey, searchQuery, selectedStoreId]);

    const fetchSubscriptions = async (searchQuery) => {
        const params = {
            subscriptionName: searchQuery?.trim() || "",
            subscriptionCode: searchQuery?.trim() || ""
        }
        if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const token = sessionStorage.getItem("Token");
            const response = await getData('subscriptions/subscriptions', params, token);
            const resultsWrapper = response?.data;
            const subscriptionsList = resultsWrapper?.results || [];
            setSubscriptions(subscriptionsList);

        } catch (error) {
            console.error('Fetch Subscriptions Error:', error);
            toast.error(error.message || 'Fetch Subscriptions Failed');
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('customers/customers', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setCustomers(results);
            } catch (error) {
                console.error("Failed to load customers", error);
            }
        };

        fetchCustomers();
    }, []);
    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || data?.data || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load Stores", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = sessionStorage.getItem("currentStoreId");
            setSelectedStoreId(storeId);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    return (
        <div className="subscription-layout">
            <div className="subscription-content">
                <main className="subscription-main">
                    {isAddSubscription ? (
                        <div className="add-subscription-form">
                            <h3>Create New Subscription Plan </h3>
                            <form className="subscription-form">
                                <div className="Subscription-form-row">
                                    <div className="Subscription-form-group">
                                        <label className="input-label">Branch Name</label>
                                        <select
                                            className="category-input"
                                            value={formData.storeId || ""}
                                            onChange={(e) => {
                                                const storeId = e.target.value;
                                                setSelectedStoreId(storeId);
                                                setFormData(prev => ({ ...prev, storeId }));
                                                sessionStorage.setItem("currentStoreId", storeId);
                                                window.dispatchEvent(new Event("storeChanged"));
                                            }}
                                        >
                                            <option value="">Select Branch</option>
                                            {stores
                                                .filter(store =>
                                                    role === "SuperAdmin" ||
                                                    (role === "Admin" && adminStoreIds.includes(store._id))
                                                )
                                                .map(store => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.storeName}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="Subscription-form-group">
                                        {/* Label + Toggle in one row */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <label htmlFor="Customer" className="input-label">
                                                Customer
                                            </label>

                                            {/* Toggle Switch */}
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={toggle}
                                                    onChange={() => {
                                                        setToggle((prev) => !prev);
                                                        if (toggle) {
                                                            // when turning OFF, clear customerId
                                                            setFormData((prev) => ({ ...prev, customerId: "" }));
                                                        }
                                                    }}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>

                                        {/* Customer Dropdown */}
                                        <select
                                            id="customerId"
                                            className="subscription-input"
                                            value={formData.customerId || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, customerId: e.target.value }))
                                            }
                                            disabled={!toggle} // disable when toggle is off
                                        >
                                            <option value="">Select Customer</option>
                                            {customers.map((cust) => (
                                                <option key={cust._id} value={cust._id}>
                                                    {cust.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>
                                <div className="Subscription-form-row">
                                    <div className="Subscription-form-group">
                                        <label htmlFor="subscriptionName" className="input-label">
                                            Subscription Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Subscription Name"
                                            required
                                            className="subscription-input"
                                            value={formData.subscriptionName || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, subscriptionName: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Subscription-form-group">
                                        <label htmlFor="subscriptionCycle" className="input-label">
                                            Subscription Cycle
                                        </label>
                                        <select
                                            id="subscriptionCycle"
                                            className="subscription-input"
                                            value={formData.subscriptionCycle || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, subscriptionCycle: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Subscription Type</option>
                                            <option value="weekly">Weekly</option>
                                            <option value="monthly">Monthly</option>
                                            <option value="yearly">Yearly</option>
                                        </select>
                                    </div>
                                    <div className="Subscription-form-group">
                                        <label htmlFor="price" className="input-label">
                                            Price
                                        </label>
                                        <div className="price-input-wrapper">
                                            <span className="price-prefix">INR</span>
                                            <input
                                                type="number"
                                                placeholder="Enter Price"
                                                required
                                                className="subscription-input1"
                                                min="0"
                                                step="0.01"
                                                value={formData.price || ""}
                                                onChange={e =>
                                                    setFormData(prev => ({ ...prev, price: e.target.value }))
                                                }
                                            />
                                        </div>
                                        {formData.price !== "" && formData.price <= 0 && (
                                            <p className="error">Price must be greater than 0</p>
                                        )}
                                    </div>
                                </div>
                                <div className="subscription-form-row">
                                    <div className="Subscription-form-group">
                                        <label htmlFor="subscriptionDescription" className="input-label">
                                            Subscription Description
                                        </label>
                                        <textarea
                                            placeholder="Enter Description"
                                            className="subscription-input"
                                            value={formData.subscriptionDescription || ""}
                                            onChange={e => {
                                                let value = e.target.value;

                                                // Auto bullet on Enter
                                                if (value.endsWith("\n")) {
                                                    value += "• ";
                                                }
                                                setFormData(prev => ({ ...prev, subscriptionDescription: value }));
                                            }}
                                            style={{ height: '100px' }}
                                        />
                                    </div>
                                    <div className="Subscription-form-group">
                                        <div className="Subscription-buttons">
                                            <button className="cancel-Subscription-button" onClick={() => navigate('/subscriptions')}>
                                                cancel
                                            </button>
                                            <button className="add-Subscription-button" type="submit" onClick={handleAddSubscription}>
                                                create Subscription
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="subscription-widgets">
                                <div className="subscription-widgets-header">
                                    <h3>Subscriptions</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="subscription-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button className="add-btn-subscription" onClick={() => navigate('/subscriptions/add')}>+ Add subscription</button>
                            </div>
                            <div className="header-divider"></div>
                            {subscriptions.length === 0 ? (
                                <p className="no-subscriptions" style={{ textAlign: 'center' }}>No subscriptions found.</p>
                            ) : (
                                <div className="subscription-cards-container">
                                    {
                                        subscriptions.map((subscription, index) => (
                                            <div key={index} className="subscription-card" style={{ backgroundColor: colors[index % colors.length] }}>
                                                <h3 className="plan-title">{subscription.subscriptionName}/{subscription.subscriptionCode}</h3>
                                                <p className="plan-price">₹{subscription.price}/{subscription.subscriptionCycle}</p>

                                                <ul className="plan-features">
                                                    {(subscription.subscriptionDescription || "")
                                                        .split("\n")
                                                        .filter(line => line.trim() !== "") // remove empty lines
                                                        .map((line, i) => (
                                                            <li key={i}>{line.replace(/^•\s*/, "")}</li>
                                                        ))
                                                    }
                                                </ul>

                                                <button className="plan-btn" onClick={() => {
                                                    setFormData({
                                                        subscriptionName: subscription.subscriptionName || '',
                                                        subscriptionDescription: subscription.subscriptionDescription || '',
                                                        price: subscription.price || '',
                                                        subscriptionCycle: subscription.subscriptionCycle || '',
                                                        storeId: subscription.storeId?._id || subscription.storeId || "",
                                                    });
                                                    setIsPopupMode(true);
                                                    setIsEditMode(true);
                                                    setEditSubscriptionId(subscription._id);
                                                }}>Edit</button>
                                            </div>
                                        ))
                                    }
                                </div>
                            )}
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    subscriptionName: '',
                                                    subscriptionDescription: '',
                                                    price: '',
                                                    subscriptionCycle: '',
                                                    storeId: '',
                                                });
                                            }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Subscription" : "Add Subscription"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateSubscription}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Branch Name</label>
                                                        <select
                                                            className="category-input"
                                                            value={formData.storeId || ""}
                                                            onChange={(e) =>
                                                                setFormData(prev => ({ ...prev, storeId: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Branch</option>
                                                            {stores
                                                                .filter(store =>
                                                                    role === "SuperAdmin" ||
                                                                    (role === "Admin" && JSON.parse(sessionStorage.getItem("storeIds") || "[]").includes(store._id))
                                                                )
                                                                .map(store => (
                                                                    <option key={store._id} value={store._id}>
                                                                        {store.storeName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="subscriptionName">Subscription Name</label>
                                                        <input
                                                            type="text"
                                                            id="subscriptionName"
                                                            className="subscription-input"
                                                            value={formData.subscriptionName}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    subscriptionName: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">

                                                    <div className="form-group">
                                                        <label className="input-label">Subscription Type</label>
                                                        <select
                                                            id="subscriptionCycle"
                                                            className="subscription-input"
                                                            value={formData.subscriptionCycle}
                                                            onChange={(e) => {
                                                                const selectedSubscriptionCycle = e.target.value;
                                                                setFormData((prev) => ({ ...prev, subscriptionCycle: selectedSubscriptionCycle }))
                                                            }}
                                                        >
                                                            <option value='' >Select Subscription Cycle</option>
                                                            <option value='weekly'>Weekly</option>
                                                            <option value='monthly'>Monthly</option>
                                                            <option value='yearly'>Yearly</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="price" className="input-label">
                                                            Price
                                                        </label>
                                                        <div className="price-input-wrapper">
                                                            <span className="price-prefix">INR</span>
                                                            <input
                                                                type="number"
                                                                placeholder="Enter Price"
                                                                required
                                                                className="subscription-input1"
                                                                min="0"
                                                                step="0.01"
                                                                value={formData.price || ""}
                                                                onChange={e =>
                                                                    setFormData(prev => ({ ...prev, price: e.target.value }))
                                                                }
                                                            />
                                                        </div>
                                                        {formData.price !== "" && formData.price <= 0 && (
                                                            <p className="error">Price must be greater than 0</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="subscriptionDescription" className="input-label">
                                                            Subscription Description
                                                        </label>
                                                        <textarea
                                                            placeholder="Enter Description"
                                                            className="subscription-input"
                                                            value={formData.subscriptionDescription || ""}
                                                            onChange={e => {
                                                                let value = e.target.value;

                                                                // Auto bullet on Enter
                                                                if (value.endsWith("\n")) {
                                                                    value += "• ";
                                                                }
                                                                setFormData(prev => ({ ...prev, subscriptionDescription: value }));
                                                            }}
                                                            style={{ height: '100px' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Subscription" : "Add Subscription"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </main>
            </div>
        </div>
    );
};

export default SubscriptionPage;
